import Header from "../header/Header";
import Footer from "../footer/Footer";
import Contactus from "../contactus/Contactus";

const Contactuspage = () => {
  return (
    <div>
      <Header />
      <Contactus />

      <Footer />
    </div>
  );
};

export default Contactuspage;
